import React, { useState } from 'react';
import language from '../language';

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = () => {
        if (!username || !password) {
            setError(language.enterCredentials);
            return;
        }

        const user = onLogin(username, password);
        if (!user) {
            setError(language.invalidCredentials);
        } else {
            setError('');
        }
    };

    return (
        <div className="login">
            <h2>{language.login}</h2>
            <input
                type="text"
                placeholder={language.enterUsername}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />
            <input
                type="password"
                placeholder={language.enterPassword}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button onClick={handleLogin}>{language.login}</button>
            {error && <p className="error">{error}</p>}
        </div>
    );
};

export default Login;